
    document.title = `${document.title} - ${__VERSION__}`;
    document.querySelector('[data-version]').innerHTML = `${__VERSION__}`;
  